import { defineMessages } from "react-intl";

export default defineMessages({
    dashboardPage: {
        id: "pages.dashboardPage.dashboardPage",
        defaultMessage: "Dashboard page",
    },
});
